module.exports = __webpack_public_path__ + "img/book_600.69d1630d.png";